import React, { Component } from "react";
import { Link } from "react-router-dom";

import API from "../../../actions/api-helper";
import UI from "../../../actions/ui-helper";
import DataUtil from "../../../actions/data";
import StringUtil from "../../../actions/string";

let wrapStyle = {
  whiteSpace: "pre-wrap",
  fontSize: "12px",
};

class ConsultaAtendimentoResultado extends Component {
  constructor(props) {
    super(props);
    this.definirPagamento = this.definirPagamento.bind(this);
  }

  definirPagamento(atendimento) {
    UI.loader("show", "Um momento...");
    if (DataUtil.validarData(atendimento.dataPagamento)) {
      atendimento.dataPagamento = "";
    } else {
      atendimento.dataPagamento = DataUtil.hoje();
    }

    API.post("/atendimentos", atendimento)
      .then(
        function (json) {
          UI.alert(json.success, json.message);
          UI.loader("hide");
          this.forceUpdate();
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.dataTable(this.tableId);
  }

  render() {
    if (this.props.resultado.length === 0) {
      return false;
    }
    this.tableId = StringUtil.uuid(5);

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="row">
            <div className="col-12 table-responsive">
              <table
                key={StringUtil.uuid(5)}
                id={this.tableId}
                className="table"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Data</th>
                    <th>Horário</th>
                    <th>Procedimento</th>
                    <th>Profissional</th>
                    <th>Paciente</th>
                    {this.props.habilitarPagamento && <th>Pagamento</th>}
                    <th>Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.resultado.map((atendimento, i) => {
                    return (
                      <tr key={atendimento.id}>
                        <td>{atendimento.id}</td>
                        <td>{atendimento.data}</td>
                        <td>
                          {atendimento.horaEntrada.substring(0, 5)} -{" "}
                          {atendimento.horaSaida.substring(0, 5)}
                        </td>
                        <td style={wrapStyle}>
                          {atendimento.procedimento.codigo +
                            " - " +
                            atendimento.procedimento.descricao}
                        </td>
                        <td style={wrapStyle}>
                          {atendimento.valores.map((valor) => {
                            return (
                              <div
                                key={valor.usuarioId}
                                className="badge badge-default badge-gray badge-xs"
                              >
                                {valor.usuarioNome}
                              </div>
                            );
                          })}
                        </td>
                        <td style={wrapStyle}>
                          {atendimento?.paciente?.idCismepar +
                            " - " +
                            atendimento?.paciente?.nome}
                        </td>
                        {this.props.habilitarPagamento && (
                          <td>
                            {atendimento.tipo === 3 && (
                              <div className="badge badge-info badge-xs">
                                Cancelado
                              </div>
                            )}
                            {atendimento.tipo < 3 &&
                              DataUtil.validarData(
                                atendimento.dataPagamento
                              ) && (
                                <button
                                  className="btn btn-xs btn-success"
                                  type="button"
                                  onClick={() =>
                                    this.definirPagamento(atendimento)
                                  }
                                >
                                  Recebido
                                </button>
                              )}
                            {atendimento.tipo < 3 &&
                              !DataUtil.validarData(
                                atendimento.dataPagamento
                              ) && (
                                <button
                                  className="btn btn-xs btn-danger"
                                  type="button"
                                  onClick={() =>
                                    this.definirPagamento(atendimento)
                                  }
                                >
                                  Pendente
                                </button>
                              )}
                          </td>
                        )}
                        <td>
                          <div className="dropdown">
                            <button
                              className="btn btn-xs btn-light btn-option icon-btn"
                              type="button"
                              id="dropdownMenuIconButton1"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="fa fa-cog"></i>
                            </button>
                            <div
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuIconButton1"
                            >
                              <Link
                                to={"/atendimento/cadastro/" + atendimento.id}
                                className="dropdown-item"
                              >
                                <i className="fa fa-edit"></i>&nbsp;Editar
                              </Link>
                              <Link
                                to={"/impressao/atendimento/" + atendimento.id}
                                className="dropdown-item"
                              >
                                <i className="fa fa-print"></i>&nbsp;Imprimir
                              </Link>
                              <Link
                                to={"/atendimento/auditoria/" + atendimento.id}
                                className="dropdown-item"
                              >
                                <i className="fa fa-clock-o"></i>&nbsp;Auditoria
                              </Link>
                              <span
                                onClick={() =>
                                  this.props.onDuplicar(atendimento, i)
                                }
                                className="dropdown-item"
                              >
                                <i className="fa fa-code-fork"></i>
                                &nbsp;Duplicar
                              </span>
                              <span
                                onClick={() =>
                                  this.props.onExcluir(atendimento, i)
                                }
                                className="dropdown-item"
                              >
                                <i className="fa fa-times"></i>&nbsp;Excluir
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaAtendimentoResultado;
